export default __webpack_public_path__ + "static/media/Blue_Dart_logo_transparent.3bc99218.png";